import React from "react";

//  Image \\
import servieceBg from "../../assets/images/Services.svg";

//  Style \\
import "../../assets/styles/sections/serviceSpaHero.scss";

const ServiceSpaHero = () => {
  return (
    <section className="spaHero">
      <div className="spaBg ">
        <div className="bg"></div>
        <img src={servieceBg} alt="" />
        <div className="container">
          <div className="spaHero_items">
            <div className="text">
              <p>Home / Services</p>
              <h2>Free Checkup</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSpaHero;
